import AbbreviationsTab from '../AbbreviationsTab'

export function AbbreviationsSettings() {
  return (
    <>
      <h2 className="text-lg text-muted-foreground mb-4">Abbreviations</h2>
      <AbbreviationsTab />
    </>
  )
}
